function PDPStickyCTA() {
    var waitForElements = setInterval(() => {
      const pageContainer = document.querySelector('body.template-product'); // SELECT A TARGET ELEMENT HERE

      // Check if current page is a gift card product by checking URL handle
      const isGiftCardProduct = window.location.pathname.includes('gift-card');

      if (typeof ranPDPStickyCTA === 'undefined' && pageContainer && !isGiftCardProduct) {
        window.ranPDPStickyCTA = true;
        clearInterval(waitForElements);
        // SCOPE CSS
        document.body.classList.add('ti017'); // UPDATE TEST NUMBER
        insertCTA();
        inserts();
        headerObs();
        trackConsentBanner();
        window.addEventListener('scroll', function () {
          stickyCTA();
        });

      } else if (isGiftCardProduct && typeof ranPDPStickyCTA === 'undefined') {
        // If it's a gift card product, mark as ran and clear interval without rendering
        window.ranPDPStickyCTA = true;
        clearInterval(waitForElements);
      }
         // Hide sticky ATC button on product pages is hidden by default
        // Show if we are in the US or if globale app is not in use 
        // or if we are on a product page that does not have the globale_exclude tag
  
        // poll while we wait for globale app to load
        const waitForGlobale = setInterval(() => {
          const stickyATC = document.querySelector('.ticta') 
  
          if( !window.glbeApp || window.glbeApp?.countryCode === 'US' || !document.querySelector('.product_info').getAttribute('data-product-tags').includes('globale_exclude')) {
            stickyATC.style.display = 'flex'
            // ECSR-764: the footer clearance in sticky-atc-style.css is keyed on this
            // class, so it is reserved only when a bar is actually there to occupy it.
            document.body.classList.add('ti017-bar-shown')
          } else {
            stickyATC.style.display = 'none'
            // Global-e hides the bar entirely for this market/product, so release the
            // space too — otherwise the page keeps a blank strip below the footer.
            document.body.classList.remove('ti017-bar-shown')
          }
  
          // Clear interval once globale app is loaded or if we are on a product page that does not have the globale_exclude tag
          if (window.glbeApp || !document.querySelector('.product_info').getAttribute('data-product-tags').includes('globale_exclude')) {
            clearInterval(waitForGlobale);          
          }
        }, 500);
      }, 100)
  }
  
  // Breakpoint the mobile bar styling uses in sticky-atc-style.css. Shared so the
  // script and the stylesheet cannot drift apart.
  var STICKY_ATC_MOBILE_QUERY = '(max-width: 850px)';

  /*
    The real add-to-cart control, and only it.

    `.btn.btn--full.add-to-cart` is not unique: BR-711 added a mirrored
    "Personalize" button to the buy row, and it matched the same selector and came
    first in the DOM. That made the bar read the wrong button for its sold-out
    state, and made its tap fire both — adding to cart and opening the monogram
    modal on top of the cart drawer. `[data-add-to-cart]` is on the real button
    alone; the class selector stays only as a fallback for any template that
    predates that attribute, and now excludes the personalize trigger explicitly.
  */
  function realAddToCartButton(scope) {
    var root = scope || '.product-single__meta';
    return document.querySelector(root + ' [data-add-to-cart]')
      || document.querySelector(root + ' .product-block button.btn.btn--full.add-to-cart:not([data-personalize-trigger])');
  }

  // ECSR-764: set by trackConsentBanner so the header observer can ask for a
  // re-measure when the header becomes stuck, which moves its bottom edge.
  var stickyATCConsentSchedule = null;

  function headerObs() {
    const header = document.querySelector('header#SiteHeader');
    const target = document.querySelector('.ticta');

    if (header && target) {
      if (header.classList.contains('site-header--stuck')) {
        target.classList.add('header-fixed');
      } else {
        target.classList.remove('header-fixed');
      }
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            // Check if the header has the 'site-header--stuck' class
            if (header.classList.contains('site-header--stuck')) {
              target.classList.add('header-fixed');
            } else {
              target.classList.remove('header-fixed');
            }
            if (stickyATCConsentSchedule) {
              stickyATCConsentSchedule();
            }
          }
        });
      });
      observer.observe(header, {
        attributes: true
      });
    }
  }

  /*
    ECSR-764: on mobile the bar sits at the bottom of the viewport, which is also
    where the OneTrust consent banner sits — ~465px tall, at a z-index nothing here
    can outrank.

    Three options were considered. Deferring the bar until consent is answered
    hides it from exactly the first-time visitors it exists for. Lifting it above
    the banner by the banner's height does not fit: at 375x667 a two-row bar ends
    up behind the sticky header. Raising the bar's z-index above the banner (the
    BR-751 pattern in custom.css.liquid) would park it permanently over the
    banner's own Accept/Reject buttons, which is a worse problem than the one it
    solves — BR-751 only does that while a drawer is transiently open.

    So while the banner is up, the bar docks to the top of the viewport instead,
    under the header, and returns to the bottom once the banner goes away. The
    banner stays fully visible and usable throughout.
  */
  function trackConsentBanner() {
    var ctaElement = document.querySelector('.ticta');
    if (!ctaElement) {
      return;
    }

    var scheduled = false;
    var watched = [];
    var bodyObserver = null;
    var lastDockTop = null;
    var bannerSeen = false;

    function isVisible(element) {
      if (!element) {
        return false;
      }
      // Note: offsetParent is null for any fixed-position element, so it cannot
      // be used to test visibility here — the banner is fixed.
      var styles = window.getComputedStyle(element);
      if (styles.display === 'none' || styles.visibility === 'hidden' || parseFloat(styles.opacity) === 0) {
        return false;
      }
      return element.getBoundingClientRect().height > 0;
    }

    function watch(element) {
      if (!element || watched.indexOf(element) !== -1) {
        return;
      }
      watched.push(element);
      // childList/subtree matters on the wrapper: OneTrust appends the wrapper
      // first and injects the banner into it a task later, and a preferences link
      // can re-inject a fresh banner node rather than un-hiding the old one.
      new MutationObserver(schedule).observe(element, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true
      });
    }

    function measure() {
      scheduled = false;

      var wrapper = document.querySelector('#onetrust-consent-sdk');
      var banner = document.querySelector('#onetrust-banner-sdk');

      // The banner alone is the measurement. Testing the #onetrust-consent-sdk
      // wrapper as well would never pass: its children are all fixed-position, so
      // it is a zero-height box even while the banner is showing. It is not needed
      // either — hiding the wrapper collapses the banner's own rect to zero, so
      // dismissal is already caught here.
      // Only the mobile bar has a docked state, so the class — and the scroll
      // re-measure it gates — stays off entirely on desktop.
      var bannerUp = isVisible(banner) && window.matchMedia(STICKY_ATC_MOBILE_QUERY).matches;

      ctaElement.classList.toggle('consent-open', bannerUp);

      if (bannerUp) {
        var header = document.querySelector('header#SiteHeader');
        // The header's *bottom edge*, not its height: at scroll 0 — which is when
        // the consent banner is up — the announcement bar sits above the header in
        // normal flow, so the header does not start at the top of the viewport.
        // Once it is stuck it is fixed at top 0 and bottom equals its height.
        var headerBottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        // The bar docks immediately under the header and never above it. An earlier
        // revision also clamped it upward to clear the banner's top edge, but on a
        // 375x667 phone that gap is only ~89px, so the clamp slid the bar behind the
        // header and hid the product name — QA caught it. The bar is made compact
        // while docked instead (see .ticta.consent-open in sticky-atc-style.css), so
        // it fits the gap without having to move up into the header.
        var dockTop = Math.max(10, headerBottom + 8);

        if (dockTop !== lastDockTop) {
          lastDockTop = dockTop;
          document.documentElement.style.setProperty('--sticky-atc-dock-top', dockTop + 'px');
        }
      }

      watch(wrapper);
      if (banner && !bannerSeen) {
        bannerSeen = true;
        watch(banner);
        // The banner may be inserted already mid fade-in, so a first measurement
        // can legitimately read opacity 0. Transitions emit no mutation records,
        // so take one deferred look rather than waiting for the next resize.
        window.setTimeout(schedule, 300);
      }

      // The broad body watch is only needed until the banner itself has been found
      // and hooked — the wrapper's own observer covers everything after that,
      // children included.
      if (wrapper && banner && bodyObserver) {
        bodyObserver.disconnect();
        bodyObserver = null;
      }
    }

    function schedule() {
      if (scheduled) {
        return;
      }
      scheduled = true;
      window.requestAnimationFrame(measure);
    }

    measure();

    // The consent SDK is injected after page load, and lands nested rather than as
    // a direct child of <body>, so this has to watch the subtree. It is discarded
    // as soon as the banner turns up.
    bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // If the SDK never loads at all — blocked, failed, or a region that gets no
    // banner — nothing would ever disconnect the subtree watch, leaving it firing
    // on every DOM insertion on the page for the rest of the session.
    window.setTimeout(function () {
      if (bodyObserver) {
        bodyObserver.disconnect();
        bodyObserver = null;
      }
      // One late look, in case the SDK was merely very slow rather than absent.
      window.setTimeout(schedule, 30000);
    }, 30000);

    window.addEventListener('resize', schedule);

    // The docked position depends on the header's bottom edge, which moves when the
    // header becomes stuck. Only worth re-measuring while the bar is actually
    // docked, which `consent-open` implies (it is mobile-gated in measure()).
    window.addEventListener(
      'scroll',
      function () {
        if (ctaElement.classList.contains('consent-open')) {
          schedule();
        }
      },
      { passive: true }
    );

    stickyATCConsentSchedule = schedule;
  }

  
  
  function stickyCTA() {
    // On mobile, visibility is handled by the IntersectionObserver in setupVisibility()
    var isMobile = window.tictaMobileMQ
      ? window.tictaMobileMQ.matches
      : window.matchMedia(STICKY_ATC_MOBILE_QUERY).matches;
    if (isMobile) {
      return;
    }
    var windowTop = window.scrollY || document.documentElement.scrollTop;
    var button = realAddToCartButton();
    var chatbox = document.querySelector('iframe#launcher');
    var ctaElement = document.querySelector('.ticta');
    if (button) {
      var buttonTop = button.getBoundingClientRect().top + window.pageYOffset;
      if (windowTop >= buttonTop) {
        ctaElement.classList.add('active');
        if (chatbox) {
          chatbox.classList.add('act');
        }
      } else {
        ctaElement.classList.remove('active');
        if (chatbox) {
          chatbox.classList.remove('act');
        }
      }
    }
  }
  
  function insertCTA() {
    const button = realAddToCartButton();
    const isSoldOut = !!(button && button.hasAttribute('disabled'));
    const atcLabel = isSoldOut ? 'SOLD OUT' : 'ADD TO CART';
    const atcAttrs = isSoldOut ? ' style="background-color:#62676f;" disabled="disabled"' : '';

    /*
      ECSR-283 client review: the mobile bar is one full-width Add to Cart button
      with the price inside its label ("ADD TO CART - $1,150.00"); the separate
      price element is gone. The product name, vendor and the mirrored
      Personalize button that ECSR-764 added are gone from it. The first
      .wrapper (thumbnail, vendor, title) is the desktop bar's and is hidden on
      mobile by sticky-atc-style.css; the .list-price span is the desktop bar's
      "(price)" suffix, hidden on mobile.
    */
    const newHtml = `
      <div class="ticta" role="region" aria-label="Add to cart">
        <div class="container">
          <div class="wrapper">
              <div class="thumbs"></div>
              <div class="details">
                  <div class="vendor"></div>
                  <div class="title"></div>
              </div>
          </div>
          <div class="wrapper">
            <div class="ticta-buttons">
              <button class="atc"${atcAttrs}><span data-sticky-atc-label>${atcLabel}</span><span class="ticta-atc-price" data-sticky-atc-price></span> <span class="list-price"> </span> </button>
            </div>
          </div>
        </div>
      </div>
      `;
    const target = document.querySelector('div#PageContainer');
    if (target) {
      target.insertAdjacentHTML('afterend', newHtml);
    }
  }
  
  function inserts() {
    const firstImage = document.querySelector('.product__thumbs--scroller img');
    if (firstImage) {
      const imageSrc = firstImage.getAttribute('src');
      const newImage = document.createElement('img');
      newImage.setAttribute('src', imageSrc);
      newImage.setAttribute('alt', 'Product Thumbnail');
      const targetElement = document.querySelector('.ticta .thumbs');
      if (targetElement) {
        targetElement.appendChild(newImage);
      }
    }
  
    const vendorElement = document.querySelector('.product-single__vendor');
    const clonedVendor = vendorElement.cloneNode(true);
    const target = document.querySelector('.ticta .details .vendor');
    if (target) {
      target.appendChild(clonedVendor);
    }
  
    const titleElement = document.querySelector('h1.h2.product-single__title');
    const clonedTitleElement = titleElement.cloneNode(true);
    const newTitleElement = document.createElement('h3');
    newTitleElement.innerHTML = clonedTitleElement.innerHTML;
    newTitleElement.classList.add('h2', 'product-single__title');
    const targetTitle = document.querySelector('.ticta .details .title');
    if (targetTitle) {
      targetTitle.appendChild(newTitleElement);
    }
  
    // Initial price + button state, then keep them in sync with the live product DOM
    syncStickyState();

    //onclick even and tracking
    jQuery('.ticta button.atc').on('click', function () {
      var realBtn = realAddToCartButton('.page-content--product');
      if (realBtn) jQuery(realBtn).trigger('click');

      // Start GA send data collection
      const allvars = document.querySelector('select[name="id"]'); 
      const selectedVar = allvars.options[allvars.selectedIndex];

      // Get the value (variant ID) of the selected option
      const variantId = selectedVar ? selectedVar.value : null;
      const variantNameAndPrice = selectedVar ? selectedVar.innerText.trim() : null; 
      const productId = document.querySelector('form input[name="product-id"]') ? document.querySelector('form input[name="product-id"]').value : null;

      // Ensure the eventData object only contains non-null values
      const eventData = {
        vwo_event_name: "pdp_stickyATC_click",
        productName: titleElement?.innerText.trim() || null,  // Safely access titleElement.innerText, default to null if titleElement is not available
        productId: productId || null,
        variantId: variantId || null,
        variantNameAndPrice: variantNameAndPrice || null
      };

      // Remove any null or undefined values from eventData before sending it
      const filteredEventData = Object.fromEntries(Object.entries(eventData).filter(([key, value]) => value != null));
 
      window.Shopify.analytics.publish("vwo_test_event", {
        ...filteredEventData
      });
    });

    // Mobile visibility: show on load, fade out only when the real buy buttons are in view
    setupVisibility();

    addSwatchClickEvent();
  }

  // Keep the sticky price + add-to-cart state mirrored to the live product DOM
  function syncStickyState() {
    const realPrice = document.querySelector('span[data-product-price]');
    const realBtn = realAddToCartButton();
    const stickyBtn = document.querySelector('.ticta button.atc');
    const stickyAtcPrice = document.querySelector('.ticta [data-sticky-atc-price]');
    const stickyListPrice = document.querySelector('.ticta .list-price');

    function applyPrice() {
      if (!realPrice) return;
      const txt = realPrice.textContent.trim();
      // Mobile button label suffix: "ADD TO CART - $1,150.00" (shown only on mobile)
      if (stickyAtcPrice) stickyAtcPrice.textContent = txt ? ' - ' + txt : '';
      if (stickyListPrice) stickyListPrice.textContent = '(' + txt + ')';
    }

    function applyBtnState() {
      if (!realBtn || !stickyBtn) return;
      const soldOut = realBtn.hasAttribute('disabled');
      // Keep the word in sync with the state: a sold-out default variant
      // followed by an in-page switch to an available one must not leave the
      // button reading "SOLD OUT - $1,150.00". The [disabled] CSS rule hides
      // the price suffix while sold out.
      const stickyLabel = stickyBtn.querySelector('[data-sticky-atc-label]');
      if (stickyLabel) stickyLabel.textContent = soldOut ? 'SOLD OUT' : 'ADD TO CART';
      if (soldOut) {
        stickyBtn.setAttribute('disabled', 'disabled');
        stickyBtn.style.backgroundColor = '#62676f';
      } else {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.style.backgroundColor = '';
      }
    }

    applyPrice();
    applyBtnState();

    if (realPrice && window.MutationObserver) {
      new MutationObserver(applyPrice).observe(realPrice, { childList: true, characterData: true, subtree: true });
    }
    if (realBtn && window.MutationObserver) {
      new MutationObserver(applyBtnState).observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  // Mobile-only: drive .active off the real buy buttons' visibility (visible on load, fade when in view)
  function setupVisibility() {
    const cta = document.querySelector('.ticta');
    const buyButtons = document.querySelector('.product-single__meta .buy-buttons-row')
      || realAddToCartButton();
    if (!cta) return;

    const mq = window.matchMedia(STICKY_ATC_MOBILE_QUERY);
    window.tictaMobileMQ = mq;

    if (!buyButtons || !window.IntersectionObserver) {
      // No buy-buttons row to track, or no observer support. Leaving the bar shown
      // on mobile is the safe failure — the shopper keeps a way to buy, which is
      // the whole reason the bar exists. Desktop still has its scroll reveal.
      if (mq.matches) {
        cta.classList.add('active');
      }
      return;
    }

    function setActive(isActive) {
      cta.classList.toggle('active', isActive);
      // Re-query: the support chat launcher loads asynchronously after this script runs
      const chatbox = document.querySelector('iframe#launcher');
      if (chatbox) chatbox.classList.toggle('act', isActive);
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        window.tictaBuyButtonsVisible = entry.isIntersecting;
        // On mobile, the bar is visible whenever the real buy buttons are NOT in view.
        if (mq.matches) {
          setActive(!entry.isIntersecting);
        }
      });
    }, { threshold: 0 });
    io.observe(buyButtons);

    // The support chat launcher loads late; once it appears, sync its offset class to
    // the current bar state (subsequent changes are handled by setActive()).
    var launcherAttempts = 0;
    var launcherSync = setInterval(function () {
      var lb = document.querySelector('iframe#launcher');
      if (lb) {
        lb.classList.toggle('act', mq.matches && cta.classList.contains('active'));
        clearInterval(launcherSync);
      } else if (++launcherAttempts > 20) {
        clearInterval(launcherSync);
      }
    }, 500);

    // Re-evaluate when crossing the mobile breakpoint / on orientation change
    function onChange() {
      if (mq.matches) {
        setActive(!window.tictaBuyButtonsVisible);
      } else {
        cta.classList.remove('active');
        stickyCTA();
      }
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }
  
  try {
    if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
      PDPStickyCTA();
    } else {
      document.addEventListener('DOMContentLoaded', PDPStickyCTA);
    }
  } catch (err) {
    const e = {
      dev: 'U02M01M9QG6',
      vwotest: 'XX', // Update VWO Test Number 
      vwodesc: 'B&R-A-Build-PDP-StickyCTA-V1-August2024 - Variation 1', // Example (SST-M-PLP-OptimizationsV1-April2023 | Variation 1)
      type: 'vwo',
      message: err.toString(),
      stack: err.stack,
      source: window.location.href
    };
    const x = new XMLHttpRequest();
    x.open('POST', 'https://us-central1-tixray.cloudfunctions.net/err', !0), x.send(JSON.stringify(e));
  }

  

  function addSwatchClickEvent() {
    const swatchLabels = document.querySelectorAll('.color-swatch.variant__button-label'); 
    swatchLabels.forEach((label) => {
      label.addEventListener('click', function () {
        const newImageSrc = this.getAttribute('primary-img'); // Get the new variant image URL 
        if (newImageSrc) {
          const stickyThumb = document.querySelector('.ticta .thumbs img'); 
          if (stickyThumb) {
            stickyThumb.setAttribute('src', newImageSrc); // Update existing image 
          } else {
            const newThumbImg = document.createElement('img');
            newThumbImg.setAttribute('src', newImageSrc);
            newThumbImg.setAttribute('alt', 'Product Thumbnail');
            document.querySelector('.ticta .thumbs').appendChild(newThumbImg);
          }
        }
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', function(){

    addSwatchClickEvent()
  })